<template>
	<div :class="{ 'opacity-40 pointer-events-none': outOfStock }">
		<div v-if="product.wasPrice && product.wasPrice > product.currentPrice" class="cursor-pointer relative z-10 flex w-full justify-start translate-y-2.5 translate-x-2.5">
			<div class="bg-ihh-salmon p-1.5 rounded-md absolute shadow">
				<div class="flex w-full px-3 text-center text-sm text-ihh-brown font-semibold">Sale</div>
			</div>
		</div>

		<div
			v-if="!birthKit && !store.editingKit?.id && (product.outOfStock || variantsOutOfStock)"
			class="cursor-pointer relative z-10 flex w-full justify-start translate-y-2.5 translate-x-2.5"
		>
			<div class="bg-ihh-coral p-1.5 rounded-md absolute shadow">
				<div class="flex w-full px-3 text-center text-sm text-ihh-white font-semibold">Out of Stock</div>
			</div>
		</div>

		<div class="cursor-pointer relative z-10 flex w-full justify-end translate-y-2.5 -translate-x-2.5">
			<!-- <div class="gradient p-1.5 rounded-md absolute shadow">
                <img v-if="wishlist" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAASElEQVR4nGNgoBFoY2Bg+MnAwPAfSreQasBPBgYGISgbRP8gRtN/EjBFhuAF/5EUYaNHDWAYCmHwk0AaIJgiW/EYQlaeoD0AAJvjVLO1j3diAAAAAElFTkSuQmCC">
                <img v-else src="/images/ob-heart-0129.svg" class="w-6 h-6" />
            </div> -->
			<div v-if="!publicList" class="gradient p-1.5 rounded-md absolute shadow">
				<button @click="removeListItem" v-if="wishlist" class="p-0 border-none bg-transparent flex">
					<img
						src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAASElEQVR4nGNgoBFoY2Bg+MnAwPAfSreQasBPBgYGISgbRP8gRtN/EjBFhuAF/5EUYaNHDWAYCmHwk0AaIJgiW/EYQlaeoD0AAJvjVLO1j3diAAAAAElFTkSuQmCC"
					/>
				</button>
				<button @click="addListItem" v-else class="p-0 border-none bg-transparent flex">
					<img src="/images/ob-heart-0129.svg" class="w-6 h-6" />
				</button>
			</div>
		</div>

		<div
			class="relative group cursor-pointer flex w-full aspect-square justify-center bg-magnolia-50/60 shadow rounded-xl items-center lg:p-6 overflow-hidden product-card"
		>
			<router-link :to="url" class="block w-full">
				<!-- Updated link to include ID -->
				<!-- <img class="w-full object-center object-cover mix-blend-darken" :src="product?.images?.[0]?.url" alt="product images" /> -->
				<div class="relative w-full aspect-square">
					<div
						:style="`background-image: url(${thumbnail})`"
						class="absolute inset-0 group-hover:opacity-0 w-full bg-center bg-contain bg-no-repeat aspect-square mix-blend-darken rounded-lg"
					/>
					<div
						:style="`background-image: url(${secondImage || thumbnail})`"
						class="absolute inset-0 opacity-0 group-hover:opacity-100 w-full bg-center bg-contain bg-no-repeat aspect-square mix-blend-darken rounded-lg"
					/>
				</div>

				<div v-if="inKitQuantity" class="w-full max-w-48 absolute bottom-8 inset-x-0 px-4 mx-auto">
					<div class="flex bg-ihh-dark-salmon rounded-full justify-between items-center px-2 text-white font-semibold">
						<button @click.stop.prevent="removeFromKit" class="rounded-full aspect-square w-8 h-8 hover:bg-ihh-salmon/50 shrink-0">-</button>
						<div class="text-sm md:text-base py-3 flex w-full justify-center text-center">
							{{ inKitQuantity }}
						</div>
						<button @click.stop.prevent="addToKit(false)" class="rounded-full aspect-square w-8 h-8 bg-ihh-salmon/50 hover:bg-ihh-salmon/80 shrink-0">+</button>
					</div>
				</div>

				<div
					class="absolute flex items-end justify-center opacity-0 bg-ihh-white/40 transition transform duration-300 ease-in-out group-hover:opacity-100"
					:class="!small ? 'inset-0' : 'bottom-0 left-0 w-full'"
					v-else-if="store.editingKit?.id && variants?.length <= 1 && !birthKit"
				>
					<button
						class="font-medium text-sm md:text-base text-ihh-midnight-gray py-3 flex w-full justify-center text-center rounded-lg tracking-wide transition transform ease-in-out bg-ihh-dark-salmon hover:bg-ihh-salmon"
						:class="!small ? 'group-hover:-translate-y-10 mx-4' : 'w-full'"
						@click.stop.prevent="addToKit(false)"
					>
						Add to Kit
					</button>
				</div>

				<div v-else-if="inCartQuantity" class="w-full max-w-48 absolute bottom-8 inset-x-0 px-4 mx-auto">
					<div class="flex bg-ihh-dark-salmon rounded-full justify-between items-center px-2 text-white font-semibold">
						<button @click.prevent="removeFromBag" class="rounded-full aspect-square w-8 h-8 hover:bg-ihh-salmon/50 shrink-0">-</button>
						<div class="text-sm md:text-base py-3 flex w-full justify-center text-center">
							{{ inCartQuantity }}
						</div>
						<button @click.prevent="addToBag" class="rounded-full aspect-square w-8 h-8 bg-ihh-salmon/50 hover:bg-ihh-salmon/80 shrink-0">+</button>
					</div>
				</div>

				<div
					class="absolute flex items-end justify-center opacity-0 bg-ihh-white/40 transition transform duration-300 ease-in-out group-hover:opacity-100"
					:class="!small ? 'inset-0' : 'bottom-0 left-0 w-full'"
					v-else
				>
					<button
						class="font-medium text-sm md:text-base text-ihh-midnight-gray py-3 flex w-full justify-center text-center rounded-lg tracking-wide transition transform ease-in-out"
						:class="addToCartButtonClasses"
						@click.prevent="addToBag(true)"
						:aria-disabled="product.outOfStock && !birthKit && !store.editingKit?.id"
					>
						<span
							v-html="
								birthKit ? `View Kit` : variants.length > 1 && !product.outOfStock ? `Choose Options` : !product.outOfStock ? `Add to Bag` : `Out of Stock`
							"
						></span>
					</button>
				</div>
			</router-link>
		</div>
		<div class="my-4">
			<div class="flex w-full px-2 sm:pb-0 text-sm flex-col" :class="!small ? 'md:text-base md:flex-row' : ''">
				<router-link :to="url" class="text-center md:text-start font-semibold tracking-wide text-ihh-midnight-gray break-words md:mr-2 leading-tight">{{
					product.name
				}}</router-link>
				<div v-if="!birthKit" class="justify-end w-full">
					<template v-if="product.wasPrice">
						<div class="flex w-full justify-end text-ihh-slate-gray font-normal tracking-wide text-center md:text-end text-sm">Was:</div>
						<div
							class="text-ihh-midnight-gray font-normal tracking-wide text-center md:text-end"
							:class="product.wasPrice ? 'line-through text-ihh-gray/75 text-sm' : ''"
						>
							${{ product.wasPrice }}
						</div>
					</template>
					<div
						v-if="product.currentPrice"
						class="flex w-full text-ihh-midnight-gray font-normal tracking-wide text-center md:text-end"
						:class="!small ? 'justify-end' : 'mt-2'"
					>
						{{ product.currentPrice.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}
					</div>
				</div>
			</div>
			<div v-if="!hideReviews" class="flex w-full justify-center md:justify-start px-2">
				<div class="flex" v-if="product.rating">
					<Stars :stars="product.rating" class="w-full max-w-[5rem] mr-2" />
					<div class="text-xs text-ihh-gray-600 m-auto flex w-full">{{ product.reviewsCount }}&nbsp;review{{ product.reviewsCount > 1 ? 's' : '' }}</div>
				</div>
			</div>
		</div>
		<WishlistModal :show="showWishlistOptions" @update:show="showWishlistOptions = $event" :product="product" />
	</div>
</template>

<script>
import Swal from 'sweetalert2'
import Stars from '../partials/stars.vue'
import Modal from '../layout/modal.vue'
import Mango from '../../helpers/mango'
import WishlistModal from './wishlist-modal.vue'

export default {
	components: { Modal, Stars, WishlistModal },
	data() {
		return {
			showWishlistOptions: false,
		}
	},
	emits: ['removeListItem'],
	inject: ['store'],
	props: {
		product: {
			type: Object,
			required: true,
		},
		wishlist: {
			type: Boolean,
			default: false,
		},
		birthKitItem: {
			type: Boolean,
			default: false,
		},
		publicList: {
			type: Boolean,
			default: false,
		},
		hideReviews: {
			type: Boolean,
			default: false,
		},
		small: {
			type: Boolean,
			default: false,
		},
		isUpsellItem: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		removeFromBag() {
			let existingItem = this.store.cart?.cartItems?.find?.((c) => c.item.id === this.product.id)
			if (!existingItem) return
			let quantity = existingItem.quantity
			if (quantity > 1) {
				existingItem.quantity -= 1
			} else {
				this.store.cart.cartItems = this.store.cart.cartItems.filter((c) => c.item.id !== this.product.id)
			}
		},
		addToBag(openBag) {
			if (this.isUpsellItem) {
				this.store.addingFromUpsell = true
			}
			if (this.birthKit || this.variants?.length > 1) {
				this.$router.push(this.url)
				return
			}

			if (this.product.outOfStock) return

			let existingItem = this.store.cart?.cartItems?.find?.((c) => c.item.id === this.product.id)
			if (existingItem) {
				existingItem.quantity += 1
			} else {
				this.store.cart?.cartItems?.push?.({
					item: this.product,
					quantity: 1,
					variant: this.variants?.[0],
				})

				// GA4 Add to Cart Event
				if (typeof gtag === 'function') {
					const product = {
						id: this.product?.sku,
						name: this.product?.name,
						quantity: 1,
						google_business_vertical: 'retail',
						currency: 'USD',
						price: this.product?.currentPrice,
					}
					gtag('event', 'add_to_cart', {
						send_to: 'AW-387509916',
						ecomm_pagetype: 'cart',
						currency: 'USD',
						items: [product],
						value: product.price,
					})
				}
			}
			if (openBag === true) this.store.showBag = true
		},
		removeFromKit() {
			let existingItem = this.store.editingKit?.products?.find?.((c) => c.product.id === this.product.id)
			if (!existingItem) return
			let quantity = existingItem.quantity
			if (quantity > 1) {
				existingItem.quantity -= 1
			} else {
				this.store.editingKit.products = this.store.editingKit?.products.filter((c) => c.product.id !== this.product.id)
			}
		},
		addToKit(goToKit) {
			let existingItem = this.store.editingKit?.products?.find?.((c) => c.product.id === this.product.id)
			if (existingItem) {
				existingItem.quantity += 1
			} else {
				this.store.editingKit?.products?.push?.({
					product: this.product,
					quantity: 1,
					variant: this.variants?.[0],
					optional: this.store.editingKit && !!this.store.birthKitOptional ? true : undefined,
				})
			}
			if (goToKit) this.$router.push(`/birthKits/${this.store.editingKit.id}/edit`)
		},
		removeListItem() {
			this.$emit('removeListItem')
		},
		addListItem() {
			this.showWishlistOptions = !this.showWishlistOptions
		},
	},
	computed: {
		url() {
			return `/${this.product.collection || 'products'}/${this.product?.customUrl?.url?.replace('/', '')?.trim() || this.product.id}`
		},
		birthKit() {
			return this.product?.collection == 'birthKits'
		},
		ihhBirthKit() {
			return this.product?.categories?.some((c) => c.name === 'Birth Kits by In His Hands')
		},
		variants() {
			return this.product?.variants || []
		},
		thumbnail() {
			return (
				this.product?.image?.url ||
				this.product?.images?.find((i) => i?.isThumbnail)?.thumbnail ||
				this.product?.images?.find((i) => i?.isThumbnail)?.url ||
				'/images/obDefaultProductImage-min.jpg'
			) // || 'https://in-his-hands.s3.amazonaws.com/uploads/in-his-hands-logo.png'
		},
		secondImage() {
			const secondary = this.product?.images?.find((img) => img.sortOrder === 1)
			if (!secondary) {
				return this.product?.images?.filter((i) => i.url != this.thumbnail)?.[0]?.thumbnail || this.product?.images?.filter((i) => i.url != this.thumbnail)?.[0]?.url
			}
			return secondary?.thumbnail || secondary?.url
		},
		inCartQuantity() {
			return this.store.cart?.cartItems?.find?.((c) => c.item.id === this.product.id)?.quantity
		},
		inKitQuantity() {
			return this.store.editingKit?.products?.find?.((c) => c.product.id === this.product.id)?.quantity
		},
		addToCartButtonClasses() {
			return [
				!this.birthKit && !this.store.editingKit?.id && this.product.outOfStock ? 'bg-ihh-gray cursor-not-allowed' : 'bg-ihh-dark-salmon hover:bg-ihh-salmon',
				this.small ? 'w-full' : 'group-hover:-translate-y-10 mx-4',
			]
		},
		variantsOutOfStock() {
			return this.product?.variants?.every((v) => v.inventoryLevel <= 0) && this.product.inventoryTracking === 'variant'
		},
	},
}
</script>

<style></style>
